var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"chart-holder"},[_c('column-chart',{attrs:{"library":_vm.chartOptions,"data":_vm.data,"colors":['#4cf2f0'],"legend":false,"height":"100%","width":"100%"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }